export default "__VITE_ASSET__DaBIu7Xd__"